/* eslint-disable */
import slick from "../util/slick.min.js";
import Lazy from "../util/jquery.lazy.min.js";
import magnificPopup from "../util/magnific-popup.min.js";
import { data } from "jquery";


export default {
  init() {

    /**
     * Slick sliders
     */
    if ($(".js-slick-calendar").length) {
      $(".js-slick-calendar").slick({
        dots: false,
        arrows: true,
        prevArrow: '.js-slick-arrow--prev',
        nextArrow: '.js-slick-arrow--next',
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }

    if ($(".js-slick-schedule").length) {
      $(".js-slick-schedule").each(function () {
        $(this).slick({
          dots: false,
          arrows: true,
          infinite: false,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: true,
        });

        // Set the active slide if has active class.
        if ($(this).find(".js-slick-schedule-active").length !== 0) {
          var index = $(this).find(".js-slick-schedule-active").parent().attr("data-slick-index");
          $(this).slick("slickGoTo", index);
        }
      });
    }
    function slickSliderHorizontal() {
      $(".js-slider--horizontal .c-posts").slick({
        dots: false,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }

    if ($(".js-slider--horizontal").length) {
      slickSliderHorizontal();
    }

    $(document).on("sf:ajaxfinish", ".searchandfilter", function () {
      slickSliderHorizontal();
    });

    /**
     * Contact list filter.
     */
    function ajax_contact_list_filter() {
      var filter = $('.js-contact-list-filter');

      $.ajax({
        url: filter.attr('action'),
        data: filter.serialize(),
        type: filter.attr('method'),
        beforeSend: function () {
          $('#js-contact-list-loading').show();
          $('#js-contact-list-loading').addClass('is-loading');
        },
        complete: function () {
          $('#js-contact-list-loading').hide();
          $('#js-contact-list-loading').removeClass('is-loading');
        },
        success: function (data) {
          $('#js-contact-list-content').html(data);
        }
      });
      return false;
    }
    $(function () {
      ajax_contact_list_filter();
    });

    $('.js-contact-list-filter select').on('change', function () {
      ajax_contact_list_filter();
    });

    /**
     * Edit functionality of the adventure pack content type.
     */
    $(".js-edit-adventure-pack").click(function (e) {
      e.preventDefault();
      var contact_first_name_value = $('#contact-first-name').val();
      var contact_last_name_value = $('#contact-last-name').val();
      var contact_email_value = $('#contact-email').val();
      var contact_phone_value = $('#contact-phone').val();
      var contact_note_value = $('#contact-note').val();
      var updates_value = $('#updates').val();
      var adventure_packs_remaining_value = $('#adventure-packs-remaining').val();
      var adventure_packs_total_value = $('#adventure-packs-total').val();
      var adventure_packs_code_value = $('#adventure-packs-code').val();

      $.ajax({
        type: "POST",
        data: {
          action: "update_adventure_pack",
          contact_first_name: contact_first_name_value,
          contact_last_name: contact_last_name_value,
          contact_email: contact_email_value,
          contact_phone: contact_phone_value,
          contact_note: contact_note_value,
          updates: updates_value,
          adventure_packs_remaining: adventure_packs_remaining_value,
          adventure_packs_total: adventure_packs_total_value,
          adventure_packs_code: adventure_packs_code_value,
        }
      });

      // Update div values.
      $('.c-card-adventure-packs-contact__value--contact-name').text(contact_first_name_value + ' ' + contact_last_name_value);
      $('.c-card-adventure-packs-contact__value--contact-email').text(contact_email_value);
      $('.c-card-adventure-packs-contact__value--contact-phone').text(contact_phone_value);
      $('.c-card-adventure-packs-contact__value--contact-note').html(contact_note_value);
      $('.c-card-adventure-packs-updates__value').html(updates_value);
      $('.js-adventure-packs-remaining').text(adventure_packs_remaining_value);
      $('.js-adventure-packs-total').text(adventure_packs_total_value);

      // Toogle active classes.
      $(this).toggleClass('this-is-active');
      $(this).parent().toggleClass('this-is-active');
    });


    /**
     * Edit functionality of the adventure pack schedule.
     */
    var available_days_value = [];
    $('.js-edit-adventure-pack-schedule.this-is-active').each(function () {
      var adventure_packs_schedule_value = { day: $(this).data('date') };
      available_days_value.push(adventure_packs_schedule_value);
    });

    $(".js-edit-adventure-pack-schedule").click(function (e) {
      e.preventDefault();
      var adventure_packs_schedule_value = { day: $(this).data('date') };

      if ($(this).hasClass('this-is-active')) {
        var index = available_days_value.findIndex(object => {
          return object.day === $(this).data('date');
        });
        available_days_value.splice(index, 1);
      } else {
        available_days_value.push(adventure_packs_schedule_value);
      }

      $.ajax({
        type: "POST",
        data: {
          action: "update_adventure_pack",
          available_days: available_days_value
        },
      });
      $(this).toggleClass('this-is-active');
    });

    /**
     * Edit functionality of a user.
     */
    $(".js-edit-user").on("click", function (e) {
      e.preventDefault();
      var form = $(this).closest('form');
      var user_id_value = form.find('#user_id').val();
      var first_name_value = form.find('#first_name').val();
      var last_name_value = form.find('#last_name').val();
      var phone_value = form.find('#phone').val();
      var user_email_value = form.find('#user_email').val();
      var short_description_value = form.find('#short_description').val();
      var beach_scout_post_value = form.find('#beach_scout_post').val();

      // Schedule 1
      var schedule_schedule_start_day_value = form.find('#schedule_schedule_start_day').val();
      var schedule_schedule_end_day_value = form.find('#schedule_schedule_end_day').val();
      var schedule_monday_value = form.find('#schedule_monday').val();
      var schedule_monday_start_time_value = form.find('#schedule_monday_start_time').val();
      var schedule_monday_end_time_value = form.find('#schedule_monday_end_time').val();
      var schedule_monday_location_value = form.find('#schedule_monday_location_locations').val();
      var schedule_tuesday_value = form.find('#schedule_tuesday').val();
      var schedule_tuesday_start_time_value = form.find('#schedule_tuesday_start_time').val();
      var schedule_tuesday_end_time_value = form.find('#schedule_tuesday_end_time').val();
      var schedule_tuesday_location_value = form.find('#schedule_tuesday_location_locations').val();
      var schedule_wednesday_value = form.find('#schedule_wednesday').val();
      var schedule_wednesday_start_time_value = form.find('#schedule_wednesday_start_time').val();
      var schedule_wednesday_end_time_value = form.find('#schedule_wednesday_end_time').val();
      var schedule_wednesday_location_value = form.find('#schedule_wednesday_location_locations').val();
      var schedule_thursday_value = form.find('#schedule_thursday').val();
      var schedule_thursday_start_time_value = form.find('#schedule_thursday_start_time').val();
      var schedule_thursday_end_time_value = form.find('#schedule_thursday_end_time').val();
      var schedule_thursday_location_value = form.find('#schedule_thursday_location_locations').val();
      var schedule_friday_value = form.find('#schedule_friday').val();
      var schedule_friday_start_time_value = form.find('#schedule_friday_start_time').val();
      var schedule_friday_end_time_value = form.find('#schedule_friday_end_time').val();
      var schedule_friday_location_value = form.find('#schedule_friday_location_locations').val();
      var schedule_saturday_value = form.find('#schedule_saturday').val();
      var schedule_saturday_start_time_value = form.find('#schedule_saturday_start_time').val();
      var schedule_saturday_end_time_value = form.find('#schedule_saturday_end_time').val();
      var schedule_saturday_location_value = form.find('#schedule_saturday_location_locations').val();
      var schedule_sunday_value = form.find('#schedule_sunday').val();
      var schedule_sunday_start_time_value = form.find('#schedule_sunday_start_time').val();
      var schedule_sunday_end_time_value = form.find('#schedule_sunday_end_time').val();
      var schedule_sunday_location_value = form.find('#schedule_sunday_location_locations').val();

      // Schedule 2
      var schedule_2_schedule_schedule_start_day_value = form.find('#schedule_2_schedule_schedule_start_day').val();
      var schedule_2_schedule_schedule_end_day_value = form.find('#schedule_2_schedule_schedule_end_day').val();
      var schedule_2_schedule_monday_value = form.find('#schedule_2_schedule_monday').val();
      var schedule_2_schedule_monday_start_time_value = form.find('#schedule_2_schedule_monday_start_time').val();
      var schedule_2_schedule_monday_end_time_value = form.find('#schedule_2_schedule_monday_end_time').val();
      var schedule_2_schedule_monday_location_value = form.find('#schedule_2_schedule_monday_location_locations').val();
      var schedule_2_schedule_tuesday_value = form.find('#schedule_2_schedule_tuesday').val();
      var schedule_2_schedule_tuesday_start_time_value = form.find('#schedule_2_schedule_tuesday_start_time').val();
      var schedule_2_schedule_tuesday_end_time_value = form.find('#schedule_2_schedule_tuesday_end_time').val();
      var schedule_2_schedule_tuesday_location_value = form.find('#schedule_2_schedule_tuesday_location_locations').val();
      var schedule_2_schedule_wednesday_value = form.find('#schedule_2_schedule_wednesday').val();
      var schedule_2_schedule_wednesday_start_time_value = form.find('#schedule_2_schedule_wednesday_start_time').val();
      var schedule_2_schedule_wednesday_end_time_value = form.find('#schedule_2_schedule_wednesday_end_time').val();
      var schedule_2_schedule_wednesday_location_value = form.find('#schedule_2_schedule_wednesday_location_locations').val();
      var schedule_2_schedule_thursday_value = form.find('#schedule_2_schedule_thursday').val();
      var schedule_2_schedule_thursday_start_time_value = form.find('#schedule_2_schedule_thursday_start_time').val();
      var schedule_2_schedule_thursday_end_time_value = form.find('#schedule_2_schedule_thursday_end_time').val();
      var schedule_2_schedule_thursday_location_value = form.find('#schedule_2_schedule_thursday_location_locations').val();
      var schedule_2_schedule_friday_value = form.find('#schedule_2_schedule_friday').val();
      var schedule_2_schedule_friday_start_time_value = form.find('#schedule_2_schedule_friday_start_time').val();
      var schedule_2_schedule_friday_end_time_value = form.find('#schedule_2_schedule_friday_end_time').val();
      var schedule_2_schedule_friday_location_value = form.find('#schedule_2_schedule_friday_location_locations').val();
      var schedule_2_schedule_saturday_value = form.find('#schedule_2_schedule_saturday').val();
      var schedule_2_schedule_saturday_start_time_value = form.find('#schedule_2_schedule_saturday_start_time').val();
      var schedule_2_schedule_saturday_end_time_value = form.find('#schedule_2_schedule_saturday_end_time').val();
      var schedule_2_schedule_saturday_location_value = form.find('#schedule_2_schedule_saturday_location_locations').val();
      var schedule_2_schedule_sunday_value = form.find('#schedule_2_schedule_sunday').val();
      var schedule_2_schedule_sunday_start_time_value = form.find('#schedule_2_schedule_sunday_start_time').val();
      var schedule_2_schedule_sunday_end_time_value = form.find('#schedule_2_schedule_sunday_end_time').val();
      var schedule_2_schedule_sunday_location_value = form.find('#schedule_2_schedule_sunday_location_locations').val();

      $.ajax({
        type: "POST",
        data: {
          action: "update_user_profile",
          user_id: user_id_value,
          first_name: first_name_value,
          last_name: last_name_value,
          phone: phone_value,
          user_email: user_email_value,
          short_description: short_description_value,
          beach_scout_post: beach_scout_post_value,
          schedule_schedule_start_day: schedule_schedule_start_day_value,
          schedule_schedule_end_day: schedule_schedule_end_day_value,
          schedule_monday: schedule_monday_value,
          schedule_monday_start_time: schedule_monday_start_time_value,
          schedule_monday_end_time: schedule_monday_end_time_value,
          schedule_monday_location_locations: schedule_monday_location_value,
          schedule_tuesday: schedule_tuesday_value,
          schedule_tuesday_start_time: schedule_tuesday_start_time_value,
          schedule_tuesday_end_time: schedule_tuesday_end_time_value,
          schedule_tuesday_location_locations: schedule_tuesday_location_value,
          schedule_wednesday: schedule_wednesday_value,
          schedule_wednesday_start_time: schedule_wednesday_start_time_value,
          schedule_wednesday_end_time: schedule_wednesday_end_time_value,
          schedule_wednesday_location_locations: schedule_wednesday_location_value,
          schedule_thursday: schedule_thursday_value,
          schedule_thursday_start_time: schedule_thursday_start_time_value,
          schedule_thursday_end_time: schedule_thursday_end_time_value,
          schedule_thursday_location_locations: schedule_thursday_location_value,
          schedule_friday: schedule_friday_value,
          schedule_friday_start_time: schedule_friday_start_time_value,
          schedule_friday_end_time: schedule_friday_end_time_value,
          schedule_friday_location_locations: schedule_friday_location_value,
          schedule_saturday: schedule_saturday_value,
          schedule_saturday_start_time: schedule_saturday_start_time_value,
          schedule_saturday_end_time: schedule_saturday_end_time_value,
          schedule_saturday_location_locations: schedule_saturday_location_value,
          schedule_sunday: schedule_sunday_value,
          schedule_sunday_start_time: schedule_sunday_start_time_value,
          schedule_sunday_end_time: schedule_sunday_end_time_value,
          schedule_sunday_location_locations: schedule_sunday_location_value,
          schedule_2_schedule_schedule_start_day: schedule_2_schedule_schedule_start_day_value,
          schedule_2_schedule_schedule_end_day: schedule_2_schedule_schedule_end_day_value,
          schedule_2_schedule_monday: schedule_2_schedule_monday_value,
          schedule_2_schedule_monday_start_time: schedule_2_schedule_monday_start_time_value,
          schedule_2_schedule_monday_end_time: schedule_2_schedule_monday_end_time_value,
          schedule_2_schedule_monday_location_locations: schedule_2_schedule_monday_location_value,
          schedule_2_schedule_tuesday: schedule_2_schedule_tuesday_value,
          schedule_2_schedule_tuesday_start_time: schedule_2_schedule_tuesday_start_time_value,
          schedule_2_schedule_tuesday_end_time: schedule_2_schedule_tuesday_end_time_value,
          schedule_2_schedule_tuesday_location_locations: schedule_2_schedule_tuesday_location_value,
          schedule_2_schedule_wednesday: schedule_2_schedule_wednesday_value,
          schedule_2_schedule_wednesday_start_time: schedule_2_schedule_wednesday_start_time_value,
          schedule_2_schedule_wednesday_end_time: schedule_2_schedule_wednesday_end_time_value,
          schedule_2_schedule_wednesday_location_locations: schedule_2_schedule_wednesday_location_value,
          schedule_2_schedule_thursday: schedule_2_schedule_thursday_value,
          schedule_2_schedule_thursday_start_time: schedule_2_schedule_thursday_start_time_value,
          schedule_2_schedule_thursday_end_time: schedule_2_schedule_thursday_end_time_value,
          schedule_2_schedule_thursday_location_locations: schedule_2_schedule_thursday_location_value,
          schedule_2_schedule_friday: schedule_2_schedule_friday_value,
          schedule_2_schedule_friday_start_time: schedule_2_schedule_friday_start_time_value,
          schedule_2_schedule_friday_end_time: schedule_2_schedule_friday_end_time_value,
          schedule_2_schedule_friday_location_locations: schedule_2_schedule_friday_location_value,
          schedule_2_schedule_saturday: schedule_2_schedule_saturday_value,
          schedule_2_schedule_saturday_start_time: schedule_2_schedule_saturday_start_time_value,
          schedule_2_schedule_saturday_end_time: schedule_2_schedule_saturday_end_time_value,
          schedule_2_schedule_saturday_location_locations: schedule_2_schedule_saturday_location_value,
          schedule_2_schedule_sunday: schedule_2_schedule_sunday_value,
          schedule_2_schedule_sunday_start_time: schedule_2_schedule_sunday_start_time_value,
          schedule_2_schedule_sunday_end_time: schedule_2_schedule_sunday_end_time_value,
          schedule_2_schedule_sunday_location_locations: schedule_2_schedule_sunday_location_value,
        }
      });

      // Update div values.
      form.find(".o-form-user__value--name").text(first_name_value + ' ' + last_name_value);
      form.find(".o-form-user__value--bio").html(short_description_value);
      form.find(".o-form-user__value--beach-scout-post").html(beach_scout_post_value);

      // Toggle active classes.
      $(this).parent('fieldset').toggleClass('this-is-active');
      $(this).toggleClass('this-is-active');
    });

    /**
     * Add active class to edit schedule of a user.
     */
    $(".js-edit-schedule").on("click", function (e) {
      e.preventDefault();
      $(this).closest('form').find('.c-schedule').toggleClass('this-is-active');
    });

    /**
     * Checked in/out functionality.
     */
    $(".js-checked-in").click(function (e) {
      e.preventDefault();
      var checked_in_data = $(this).data("checked-in");
      var user_id = $(this).data("user-id");

      if (checked_in_data == 0) {
        var checked_in_value = 1;
        localStorage.setItem("checked-in", "yes");
        $(this).data('checked-in', 1);
      } else {
        var checked_in_value = 0;
        localStorage.setItem("checked-in", "no");
        $(this).data('checked-in', 0);
      }

      //$(document).find(".js-checked-in[data-user-id=" + user_id + "]").attr("data-checked-in", checked_in_value);
      $(document).find(".js-checked-in[data-user-id=" + user_id + "]").toggleClass("is-checked");
      $(document).find(".js-checked-in-status[data-user-id=" + user_id + "]").toggleClass("is-checked");

      $.ajax({
        type: "POST",
        data: {
          action: "update_user_profile",
          user_id: user_id,
          checked_in: checked_in_value,
        },
      });
    });

    /**
     * Toggle checkbox value/class
     */
    $(".js-toggle-checkbox").on("click", function () {
      var $this = $(this);
      $this.toggleClass("this-is-active");
      $this.parent().toggleClass("this-is-active");

      var checkbox = $this.children("input[type=checkbox]");
      var checkbox_value = checkbox.val();
      checkbox.val(checkbox_value === "0" ? "1" : "0");

      if (checkbox_value === "0") {
        checkbox.attr("checked", true);
      } else {
        checkbox.attr("checked", false);
      }
    });

    /**
     * Hide/show the user avatar submit button.
     */
    $(".wpua-edit .submit").hide();
    $("#wpua-add-existing").click(function () {
      $(".wpua-edit .submit").show();
    });

    /**
     * Group events and add header.
     */
    function groupEvents(target) {
      if ($(target).attr("aria-controls")) {
        var container_id = "#" + $(target).attr("aria-controls");
      } else {
        var container_id = target;
      }

      var event_groups = {};
      $(container_id + " *[data-event-grouping]").each(function () {
        var attr = $(this).attr("data-event-grouping");
        var group = event_groups[attr];
        if (!group) {
          group = event_groups[attr] = [];
        }
        group.push(this);
      });

      $(container_id + " .c-events").remove();

      for (var group in event_groups) {
        if (group) {
          var group_slug = group
            .toLowerCase()
            .replace(/ /g, "-")
            .replace(/[^\w-]+/g, "");
          var $events_container = $(
            '<div id="' + group_slug + '" class="c-events" />'
          );
          $events_container.append(
            '<div class="c-events__header"><h3>' +
            group +
            '</h3><a href="/adventure/' +
            group_slug +
            '" class="o-button">Class Details</a></div>'
          );
          $events_container.append(event_groups[group]);
          $(container_id).append($events_container);
        }
      }
    }

    // $(document).ready(function () {
    //   groupEvents(
    //     ".tribe-events-calendar-month-mobile-events__mobile-day.c-posts"
    //   );
    // });

    // if (location.pathname == '/events/') {
    //   groupEvents(
    //     ".search-filter-results .c-posts"
    //   );
    // }

    // $("body").on(
    //   "click",
    //   ".tribe-events-calendar-month__day-cell:not(.tribe-events-calendar-month__day-cell--active)",
    //   function (event) {
    //     groupEvents(this);
    //   }
    // );

    /**
     * Tabs
     */
    document.querySelectorAll(".js-tab").forEach((element) => {
      element.addEventListener("click", (e) => {
        var tab_id = element.getAttribute("data-tab");
        var tab = document.querySelector("#" + tab_id);

        // If tab is a link, allow default.
        if (element.classList.contains("js-tab-link")) {
        } else {
          e.preventDefault();
        }

        // Push hash to url.
        window.history.pushState('', '/', "#" + tab_id)

        document.querySelectorAll(".js-tab, .js-tab-content").forEach((el) => {
          el.classList.remove("is-active");
        });

        element.classList.add("is-active");
        if (tab) {
          tab.classList.add("is-active");
          $("#" + tab_id).Lazy({
            loadContent: function (element) {
              element.load();
            },
          });

          // Update heading based on active tab.
          $(".c-tabs__heading").text($('.js-tab.is-active').text());
        }
      });
    });

    $(document).ready(function () {
      // Add class to tab content.
      if ($(".js-tab").length) {
        $(".js-tab").each(function () {
          var tab_id = $(this).attr("data-tab");
          $("#" + tab_id).addClass("js-tab-content");
          $("#" + tab_id).attr("data-loader", "loadContent");
        });
      }

      // Add active classes to tabs.
      var hash = window.location.hash;
      if (hash) {
        // Make tab active if hash in url.
        $('.js-tab').removeClass("is-active");
        $(hash).addClass("is-active");
        $('[data-tab=' + hash.substring(1) + ']').addClass("is-active");
      } else if ($(".js-tab").hasClass("is-active")) {
        // Make the first tab active.
        var tab_active_id = $(".js-tab.is-active").attr("data-tab");
        $("#" + tab_active_id).addClass("is-active");
      }

      // Update heading based on active tab.
      if ($('.js-tab').hasClass('is-active')) {
        $(".c-tabs__heading").text($('.js-tab.is-active').text());
      }
    });

    // Remove active tab classes on Profile page load.
    if (window.location.href.indexOf("/profile/") > -1) {
      $(".js-tab").on("click", function () {
        $(".c-profile-nav .this-is-active").removeClass("this-is-active");
        $(".o-form-user").hide();
        $(".c-tabs .o-heading").text($(this).text());
      });

      $(".c-profile-nav a:nth-child(2), .c-primary-nav__profile").on("click", function () {
        $(".js-tab.is-active").removeClass("is-active");
        $(".js-tab-content.is-active").removeClass("is-active");
        $(".c-tabs .o-heading").text("Your Profile");

        $(this).addClass("this-is-active");
        $(".o-form-user").show();
        $(".o-form-user .js-slick-schedule").slick('setPosition');

        return false;
      });
    }

    // Make adventure packs tab active on single pages.
    if (window.location.href.indexOf("/adventure-packs/") > -1) {
      $(".js-tab.is-active").removeClass("is-active");
      $(".js-tab[data-tab='adventure-packs']").addClass("is-active");
    }

    /**
     * Smooth scrolling on anchor clicks.
     */
    // $('a[href*="#"]:not([href="#"])').click(function () {
    //   // $('.c-primary-nav, body').removeClass('primary-nav-is-active');
    //   if (
    //     location.pathname.replace(/^\//, "") ==
    //       this.pathname.replace(/^\//, "") &&
    //     location.hostname == this.hostname
    //   ) {
    //     var target = $(this.hash);
    //     target = target.length
    //       ? target
    //       : $("[name=" + this.hash.slice(1) + "]");
    //     if (target.length) {
    //       $("html, body").animate(
    //         {
    //           scrollTop: target.offset().top,
    //         },
    //         1000
    //       );
    //       return false;
    //     }
    //   }
    // });



    /**
     * Prevent page jump if hash in url.
     */
    if (location.hash && window.location.href.indexOf("/events/") > -1) {
      setTimeout(function () {
        window.scrollTo(0, 0);
      }, 1);
    }

    /**
     * Smooth scrolling if hash and 'events' is in url.
     */
    if (window.location.hash && window.location.href.indexOf("/events/") > -1) {
      var hash = window.location.hash;
      if ($(hash).length) {
        setTimeout(function () {
          $("html, body").animate(
            {
              scrollTop: $(hash).offset().top - 10,
            },
            1000
          );
        }, 1000);
      }
    }

    /**
     * Add active class to filter on page visit.
     */
    $(".c-filter a").each(function () {
      if (this.hash == window.location.hash) {
        $(this).addClass('is-active');
      }
      $(this).click(function () {
        $('.c-filter a').removeClass('is-active');
        $(this).addClass('is-active');
      });
    });

    /**
     * Open modal if #book is in url.
     */
    if (window.location.href.indexOf("#book") != -1) {
      $(document.body).addClass("ticket-modal-is-active");
    }

    // Remove hash from url on click of modal button.
    $(".c-modal button").click(function () {
      var uri = window.location.toString();

      if (uri.indexOf("#") > 0) {
        var clean_uri = uri.substring(0, uri.indexOf("#"));
        window.history.replaceState({}, document.title, clean_uri);
      }
    });

    /**
     * Magnigic Popup
     */
    if ($(".js-gallery").length) {
      $(".js-gallery").each(function () {
        $(this).magnificPopup({
          delegate: "a",
          type: "image",
          gallery: {
            enabled: true,
          },
        });
      });
    }

    /**
     * General helper function to support toggle functions.
     */
    var toggleClasses = function (element) {
      var $this = element,
        $togglePrefix = $this.data("prefix") || "this";

      // If the element you need toggled is relative to the toggle, add the
      // .js-this class to the parent element and "this" to the data-toggled attr.
      if ($this.data("toggled") == "this") {
        var $toggled = $this.closest(".js-this");
      } else {
        var $toggled = $("." + $this.data("toggled"));
      }
      if ($this.attr("aria-expanded", "true")) {
        $this.attr("aria-expanded", "true");
      } else {
        $this.attr("aria-expanded", "false");
      }
      $this.toggleClass($togglePrefix + "-is-active");
      $toggled.toggleClass($togglePrefix + "-is-active");

      // Remove a class on another element, if needed.
      if ($this.data("remove")) {
        $("." + $this.data("remove")).removeClass($this.data("remove"));
      }
    };

    /*
     * Toggle Active Classes
     *
     * @description:
     *  toggle specific classes based on data-attr of clicked element
     *
     * @requires:
     *  'js-toggle' class and a data-attr with the element to be
     *  toggled's class name both applied to the clicked element
     *
     * @example usage:
     *  <span class="js-toggle" data-toggled="toggled-class">Toggler</span>
     *  <div class="toggled-class">This element's class will be toggled</div>
     *
     */
    $(document).on("click", ".js-toggle", function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggleClasses($(this));
    });

    // Toggle parent class
    $(document).on("click", ".js-toggle-parent", function (e) {
      e.preventDefault();
      var $this = $(this);
      $this.toggleClass("this-is-active");
      $this.parent().toggleClass("this-is-active");
    });

    // Prevent bubbling to the body. Add this class to the element (or element
    // container) that should allow the click event.
    $(".js-stop-prop").on("click", function (e) {
      e.stopPropagation();
    });

    // Toggle hovered classes
    $(".js-hover").on("mouseenter mouseleave", function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggleClasses($(this));
    });

    $(".js-hover-parent").on("mouseenter mouseleave", function (e) {
      e.preventDefault();
      var $this = $(this);
      $this.toggleClass("this-is-active");
      $this.parent().toggleClass("this-is-active");
    });


    /**
     * Formmat Phone Number value.
     */
    function formatPhoneNumber(phoneNumberString) {
      var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
      var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        var intlCode = (match[1] ? '+1 ' : '');
        return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
      }
      return null;
    }


    /*************
     *
     * KLAVIYO API CALLS
     *
     * Here starts all of the Klaviyo API calls for various scenarios.
     * Organization of the calls are as follows:
     *
     * 1. RSVP Functionality
     *  - Includes mutation observer & cookie function to get feedback from PHP ticket creation
     *  - Starts by gathering data from RSVP form submission
     *  - Sends to async function in "pdf-waviers.js" to create and save PDF waivers
     *  - Once waivers are saved we make two Klaviyo calls for "Class Signup" event
     *  --- First call is actual Class Signup event and creates the account if needed
     *  --- Second is a call to PHP to set SMS consent with private API key after first call is complete
     *
     * 2. Self Cancelation
     *  - Made when user cancels a class
     *  - Includes a PHP call to remove tickets from Wordpress
     *
     * 3. Weather Cancelation
     *  - Made when a staff members clicks a button in the front facing roster tool
     *  - Includes a call to the async function found in "weather-cancelation.js"
     *
     * 4. Student Checkin -- aka Post Class
     *  - When a student is checked in via front facing roster tool
     *    we get their information from PHP and make a call out to a function
     *    called "postClassTrigger()" found in the "weather-cancellation.js" file
     *************/

    /**
     * 1. RSVP Functionality
     */
    // Basic functions to get/check cookie value that we need from PHP
    function getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

    const debug = false;

    // Setup mutation to check for PHP ticket creation
    var klaviyoMutationTarget = $('.tribe-tickets__rsvp-wrapper')[0];
    var klaviyoMutationConfig = { attributes: true, childList: true, subtree: true };

    if (klaviyoMutationTarget) {
      var klaviyoMutationObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          var newNodes = mutation.addedNodes;
          if (newNodes !== null) {
            var $nodes = $(newNodes);
            $nodes.each(function () {
              var $node = $(this);
              if ($node.hasClass('tribe-tickets__rsvp-message--success')) {
                $(".js-rsvp-status .js-confirmed-item[data-id='tickets']").addClass("complete");
                if ($(".js-rsvp-status .js-confirmed-item[data-id='klaviyo']").hasClass("complete")) {
                  setTimeout(function () {
                    $('.js-rsvp-status').addClass('js-fade-away');
                  }, 1800);
                }
              }
            });
          }
        });
      });
      klaviyoMutationObserver.observe(klaviyoMutationTarget, klaviyoMutationConfig);
    }

    // Klaviyo Object Variables
    var klaviyoCustomer = new Object();
    var klaviyoEvent = new Object();




    $("#sms-opt-in").on("change", function () {
      $("#sms-opt-in-message").toggle();
    });


    // RSVP Form Submission - Klavyio API Calls
    $("form[name='tribe-tickets-rsvp-form-ari']").on("submit", function (e) {


      // Add status overlay when form is submitted
      $('.js-rsvp-status').addClass('js-processing');
      $("form[name='tribe-tickets-rsvp-form-ari']").hide();

      //SMS Consent is mandatory
      klaviyoCustomer.$consent = ["sms"];


      // Gather all info needed from rsvp form submission
      let reminderEvent = $('.js-klaviyo-info[name="newEvent"]').val();
      let staffArray = $('.js-klaviyo-info[name="staff"]').val();
      let staff = JSON.parse(staffArray);

      $('.js-klaviyo-info').each(function () {
        let klaviyoField = $(this);
        if (klaviyoField.hasClass('js-klaviyo-info--email')) {
          klaviyoCustomer.email = klaviyoField.val();
        } else if (klaviyoField.hasClass('js-klaviyo-info--name')) {
          let fullName = klaviyoField.val().split(" ");
          klaviyoCustomer.first_name = fullName[0];
          klaviyoCustomer.last_name = fullName[1];
        }
        else if (klaviyoField.hasClass('js-klaviyo-info--phone')) {
            klaviyoCustomer.phone_number = klaviyoField.val();
            klaviyoCustomer.phone_number_formatted = formatPhoneNumber(klaviyoField.val());
        }
        else if (klaviyoField.hasClass('js-klaviyo-info--classId')) {
          // klaviyoEvent.$event_id = klaviyoField.val();
        }
        else {
          let fieldName = klaviyoField.attr('name');
          let fieldValue = klaviyoField.val();

          if (reminderEvent == 'Join the Pinfish Patrol') {
            if (fieldName == 'newstartDate') {
              klaviyoCustomer.Reminder_Pinfish = fieldValue;
            }
            else if (fieldName == 'startTime') {
              klaviyoCustomer.Reminder_Pinfish_Start = fieldValue;
            }
            else if (fieldName == 'endTime') {
              klaviyoCustomer.Reminder_Pinfish_End = fieldValue;
            }
            else if (fieldName == 'eventLocation') {
              klaviyoCustomer.Reminder_Pinfish_Location = fieldValue;
            }
            else if (fieldName == 'eventLocationInfo') {
              klaviyoCustomer.Reminder_Pinfish_Address = fieldValue;
            }
            else if (fieldName == 'eventLocationMap') {
              klaviyoCustomer.Reminder_Pinfish_Map = fieldValue;
            }
          }
          if (reminderEvent == 'Get Yourself OnBoard') {
            if (fieldName == 'newstartDate') {
              klaviyoCustomer.Reminder_OnBoard = fieldValue;
            }
            else if (fieldName == 'startTime') {
              klaviyoCustomer.Reminder_OnBoard_Start = fieldValue;
            }
            else if (fieldName == 'endTime') {
              klaviyoCustomer.Reminder_OnBoard_End = fieldValue;
            }
            else if (fieldName == 'eventLocation') {
              klaviyoCustomer.Reminder_OnBoard_Location = fieldValue;
            }
            else if (fieldName == 'eventLocationInfo') {
              klaviyoCustomer.Reminder_OnBoard_Address = fieldValue;
            }
            else if (fieldName == 'eventLocationMap') {
              klaviyoCustomer.Reminder_OnBoard_Map = fieldValue;
            }
          }
          if (reminderEvent == 'See Creatures') {
            if (fieldName == 'newstartDate') {
              klaviyoCustomer.Reminder_Creatures = fieldValue;
            }
            else if (fieldName == 'startTime') {
              klaviyoCustomer.Reminder_Creatures_Start = fieldValue;
            }
            else if (fieldName == 'endTime') {
              klaviyoCustomer.Reminder_Creatures_End = fieldValue;
            }
            else if (fieldName == 'eventLocation') {
              klaviyoCustomer.Reminder_Creatures_Location = fieldValue;
            }
            else if (fieldName == 'eventLocationInfo') {
              klaviyoCustomer.Reminder_Creatures_Address = fieldValue;
            }
            else if (fieldName == 'eventLocationMap') {
              klaviyoCustomer.Reminder_Creatures_Map = fieldValue;
            }
          }
          if (reminderEvent == 'Surf\'s Up') {
            if (fieldName == 'newstartDate') {
              klaviyoCustomer.Reminder_Surf = fieldValue;
            }
            else if (fieldName == 'startTime') {
              klaviyoCustomer.Reminder_Surf_Start = fieldValue;
            }
            else if (fieldName == 'endTime') {
              klaviyoCustomer.Reminder_Surf_End = fieldValue;
            }
            else if (fieldName == 'eventLocation') {
              klaviyoCustomer.Reminder_Surf_Location = fieldValue;
            }
            else if (fieldName == 'eventLocationInfo') {
              klaviyoCustomer.Reminder_Surf_Address = fieldValue;
            }
            else if (fieldName == 'eventLocationMap') {
              klaviyoCustomer.Reminder_Surf_Map = fieldValue;
            }
          }
          if (reminderEvent == 'Surf Safety') {
            if (fieldName == 'newstartDate') {
              klaviyoCustomer.Reminder_Safety = fieldValue;
            }
            else if (fieldName == 'startTime') {
              klaviyoCustomer.Reminder_Safety_Start = fieldValue;
            }
            else if (fieldName == 'endTime') {
              klaviyoCustomer.Reminder_Safety_End = fieldValue;
            }
            else if (fieldName == 'eventLocation') {
              klaviyoCustomer.Reminder_Safety_Location = fieldValue;
            }
            else if (fieldName == 'eventLocationInfo') {
              klaviyoCustomer.Reminder_Safety_Address = fieldValue;
            }
            else if (fieldName == 'eventLocationMap') {
              klaviyoCustomer.Reminder_Safety_Map = fieldValue;
            }
          }

          if (fieldName == "staff") {
            klaviyoEvent.staff = staff;
          }
          else {
            klaviyoEvent[fieldName] = fieldValue;
          }
        }
      });




      // Call function to generate and save waivers
      let guardianName = $(".js-klaviyo-info--name").val();
      let guardianEmail = $(".js-klaviyo-info--email").val();
      let guardianPhone = $(".js-klaviyo-info--phone").val();
      let className = $(".js-klaviyo-info[name='newEvent']").val();
      let classDate = $(".js-klaviyo-info[name='newstartDate']").val();

      let waiverURL;
      if (window.location.href.match('localhost')) {
        waiverURL = 'http://localhost:8080/wp-content/uploads/2022/09/Waiver-ECSC-Release-of-Liability-form.pdf';
      } else {
        waiverURL = $(".tribe-common-b3.tribe-tickets__form-field-description a").attr('href');
        //TODO implement a proper fix
        //this is problematic because it just looks for the first href in the field
      }




      let children = [];

      $('.tribe-tickets__rsvp-ar-form-guest').each(function (index) {
        let childName = $(this).find("input[name*='childs-name']").val();
        let childAge = $(this).find("input[name*='childs-age']").val();
        children = [...children, [childName, childAge]];
      });

      // Creating a global children variable to be able to be used later
      Window.globalChildrenVariable = children;

      // Call async PDF function in "/resources/assets/scripts/util/pdf-waivers.js"
      // console.log(`guardianName ${guardianName}`);
      // console.log(`guardianEmail ${guardianEmail}`);
      // console.log(`guardianPhone ${guardianPhone}`);
      // console.log(`children ${children}`);
      // console.log(`className ${className}`);
      // console.log(`classDate ${classDate}`);
      // console.log(`waiverURL ${waiverURL}`);


        modifyPDF(guardianName, guardianEmail, guardianPhone, children, className, classDate, waiverURL)
        .catch((error) => {
          /***
           * something failed with loading or signing thte waiver
           * if we can't load or sign the waiver we must abort the process
          */

          $(".js-rsvp-status .js-confirmed-item[data-id='tickets']").css("display","none");
          $(".js-rsvp-status .js-confirmed-item[data-id='waivers']").css("display","none");
          $(".js-rsvp-status .js-confirmed-item[data-id='klaviyo']").css("display","none");
          $(".js-rsvp-status .js-error").css("display","inline");
          return false;
        });
    });

    // Klaviyo Event API Call (we add window to make it accessible in global scope for other files to call)
    window.klaviyoClassSignupEventAPI = function (signedWaiver) {
      $(".js-rsvp-status .js-confirmed-item[data-id='waivers']").addClass("complete");

      klaviyoEvent.eventWaiver = signedWaiver;
      var object_id = getCookie('klaviyo_order_id');

      // We pass the ticket ID to the event
      klaviyoEvent.objectId = object_id;

      // We also pass the ticket ID as a profile property specific to the class
      // so that we can utilize it later for the reminder series
      if (klaviyoCustomer.Reminder_Pinfish) {
        console.log('Pinfish Class');
        klaviyoCustomer.Cancel_Pinfish = object_id;
        klaviyoCustomer.Reminder_Pinfish_Waiver = signedWaiver;
      }
      else if (klaviyoCustomer.Reminder_OnBoard) {
        console.log('OnBoard Class');
        klaviyoCustomer.Cancel_OnBoard = object_id;
        klaviyoCustomer.Reminder_OnBoard_Waiver = signedWaiver;
      }
      else if (klaviyoCustomer.Reminder_Creatures) {
        console.log('Creatures Class');
        klaviyoCustomer.Cancel_Creatures = object_id;
        klaviyoCustomer.Reminder_Creatures_Waiver = signedWaiver;
      }
      else if (klaviyoCustomer.Reminder_Surf) {
        console.log('Surf Class');
        klaviyoCustomer.Cancel_Surf = object_id;
        klaviyoCustomer.Reminder_Surf_Waiver = signedWaiver;
      }
      else {
        console.log('Surf Safety Class');
        klaviyoCustomer.Cancel_Safety = object_id;
        klaviyoCustomer.Reminder_Safety_Waiver = signedWaiver;
      }


      var klaviyoCustomerProperties = JSON.stringify(klaviyoCustomer);
      var klaviyoEventProperties = JSON.stringify(klaviyoEvent);

      console.log(klaviyoCustomerProperties);
      console.log(klaviyoEventProperties);


      $.ajax({
        method: "POST",
        url: "/wp-content/themes/little-adventures/app/klaviyo-api.php",
        data: {
          firstName: klaviyoCustomer.first_name,
          lastName: klaviyoCustomer.last_name,
          email: klaviyoCustomer.email,
          phone: klaviyoCustomer.phone_number,
          guid: 'A98C5A1E-A742-4808-96FA-6F409E799937',
          properties: klaviyoEvent,
          customerProperties: klaviyoCustomer,
          eventName: 'Class Signup',
          action: 'track'
        }
      }).done(function (response) {
        console.log("Response from PHP: " + response);
          callSMSConsent();

      });
      /**
       * callSMSConsent
       * determines wether or not we need to note that the user has granted SMS consent.
       * p.s. Klayvio's new API's all have to be called server side otherwise they will throw a CORS error
       */
      function callSMSConsent() {
        console.log('inside callSMSConsent()');
        console.log(`klaviyoCustomer.first_name ${klaviyoCustomer.first_name}`);
        console.log(`klaviyoCustomer.last_name ${klaviyoCustomer.last_name}`);
        console.log(`klaviyoCustomer.email ${klaviyoCustomer.email}`);
        console.log(`klaviyoCustomer.phone_number ${klaviyoCustomer.phone_number}`);

          $.ajax({
            method: "POST",
            url: "/wp-content/themes/little-adventures/app/klaviyo-api.php",
            data: {
              firstName: klaviyoCustomer.first_name,
              lastName: klaviyoCustomer.last_name,
              email: klaviyoCustomer.email,
              phone: klaviyoCustomer.phone_number,
              guid: 'A98C5A1E-A742-4808-96FA-6F409E799937',
              action: 'smsConsent'
            }
          }).done(function (response) {

            console.log("Response from PHP: " + response);
            $(".js-rsvp-status .js-confirmed-item[data-id='klaviyo']").addClass("complete");
            if ($(".js-rsvp-status .js-confirmed-item[data-id='tickets']").hasClass("complete")) {

              setTimeout(function () {
                $('.js-rsvp-status').addClass('js-fade-away');
                //var message = $(".tribe-tickets__rsvp-message-text").val();
                //console.log(`RSVP Message is ${message}`);
                $(".tribe-tickets__rsvp-message-text").html('\n\t<strong>\n\t\tYour RSVP has been received! \t</strong>\n\n\tCheck your text messages for RSVP confirmation.');

              }, 1800);
              klaviyoMutationObserver.disconnect();
            }

          });

      }

      // This is delayed since a race condition with the 'klayviyo_order_id' cookie being updated and set was found. This ensures that the cookie has had enough time to be updated before continuing.
      setTimeout(() => {
        object_id = getCookie('klaviyo_order_id');
        console.log('this is delayed', object_id);


        let ticketIDsArray = (function () {
          let returnedArray = [];
          let numberOfTickets = Window.globalChildrenVariable.length;

          for (let i = 0; i < numberOfTickets; i++) {
            returnedArray.push(object_id - i)
          }

          return returnedArray;
        })();

        // console.log('Ticket IDs Array', ticketIDsArray)
        // console.log('Ticket Order ID', object_id);

        // Additionally, sending the "ticket_ids" which is an array that holds all of the post IDs of all of the tickets not just the order ID. This allows for multiple children.
        console.log(`calling update_ticket_order`);
        console.log(`order id ${object_id}`);

        $.ajax({
          type: "POST",
          data: {
            action: "update_ticket_order",
            ticket_order_id: object_id,
            ticket_ids: ticketIDsArray,
            _tribe_rsvp_phone: klaviyoCustomer.phone_number_formatted,
          },
        });




      }, 5000)
    }



    /**
     * 2. User Cancelation Functionality
     */
    // $('.js-cancel-order').on('click', function(e){
    $("#cancel-class-form").on("submit", function (e) {
      e.preventDefault();
      const form = $("#cancel-class-form");
      const data = $("#cancel-class-form :input").serializeArray();
      const orders = data.filter((data) => data.name == "order_id[]");

      const debug = false;


      if (debug) console.log('Debugging form submission......')



      //console.log(orders.length);
      if (orders.length == 0) {
        alert('Please select a class to cancel');
        return;
      }



      const order_list = [];
      const event = data.filter((data) => data.name == "event_id[]");
      const event_id = event[0].value;
      const cancelProfile = new Object();
      const cancelEvent = new Object();


      orders.forEach((element) => {
        const info = element.value.split('--');
        const order_id = info[0];
        const name = info[1].split(' ');
        const firstName = name[0];
        const lastName = name[1];
        const email = info[2];
        const class_name = info[3];
        const event_date = info[4];
        const event_time = info[5];

        order_list.push(order_id);

        cancelProfile.email = email;
        cancelProfile.first_name = firstName;
        cancelProfile.last_name = lastName;
        cancelEvent.cancel_name = info[1];
        cancelEvent.cancel_email = email;
        cancelEvent.cancel_class = class_name;
        cancelEvent.cancel_date = event_date;
        cancelEvent.cancel_time = event_time;


        //if (debug) {
        console.log(`data ${data}`);
        console.log(`orders ${orders}`);
        console.log(`order_list ${order_list}`);
        console.log(`event_id ${event_id}`);
        //}


        var cancelCustomerProperties = JSON.stringify(cancelProfile);
        var cancelEventProperties = JSON.stringify(cancelEvent);

        //console.log(Object.entries(data));

        console.log(`cancelCustomerProperties ${cancelCustomerProperties}`);
        console.log(`cancelEventProperties ${cancelEventProperties}`);
        // console.log(`orders_value ${orders_value}`);
        // console.log(`event id ${event_id}`);

        cancelOrder(debug, order_list, event_id, cancelCustomerProperties, cancelEventProperties)

      });
    });


    /***
     * cancelOrder
     * call AJAX Call to PHP to cancel orders and call Klaviyo API when complete
     */

    function cancelOrder(debug, order_list, event_id, cancelCustomerProperties, cancelEventProperties) {

      if (debug) {
        console.log('Debugging cancelation orders, cancelationAPICall() would be called here');
        console.log('Removing tickets...');
        $('.c-card-rsvp-details, .c-content-page-cancel-reschedule__hero, .c-content-page-cancel-reschedule__buttons').addClass('u-display--hidden').hide();
        $('.c-card-message').removeClass('u-display--hidden').addClass('u-display--block');
        return
      }


      // Remove the ticket from WordPress

      $.ajax({
        beforeSend: function () {
          console.log('Removing tickets from WordPress...');
          $('.c-card-rsvp-details__container:first').addClass('u-deleting-tickets');

        },
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        data: {
          action: "delete_ticket_order",
          orders: order_list,
          event_id: event_id,
          customer: cancelCustomerProperties,
          event: cancelEventProperties
        },
      }).done(function () {

        window.location.href = "/user-classes/?user_email=done";

        // This works if we're remaining on the same page.
        // It doesn't work becuase we're doing a post
        // $('.c-card-rsvp-details, .c-content-page-cancel-reschedule__hero, .c-content-page-cancel-reschedule__buttons').addClass('u-display--hidden').hide();
        // $('.c-card-message').removeClass('u-display--hidden').addClass('u-display--block');


        cancelationAPICall(cancelCustomerProperties, cancelEventProperties);
      });

    }

    /***
     * cancelationAPICall
     * sends the cancelation request to Klaviyo
     */
    function cancelationAPICall(customer, event) {
      const customerParsed = JSON.parse(customer);
      const eventParsed = JSON.parse(event);

      $.ajax({
        method: "POST",
        url: "/wp-content/themes/little-adventures/app/klaviyo-api.php",
        data: {
          firstName: customerParsed.first_name,
          lastName: customerParsed.last_name,
          email: customerParsed.email,
          guid: 'A98C5A1E-A742-4808-96FA-6F409E799937',
          properties: eventParsed,
          customerProperties: customerParsed,
          eventName: 'Cancelled',
          action: 'track'
        }
      }).done(function (response) {
        console.log(response + " - Completed Klaviyo call")
      });
    }


    /**
     * 3. Weather Cancelation Functionality
     */
    $('.js-weather-cancel').on('click', function (e) {
      e.preventDefault();
      $(this).parents('.c-card-tribe-event').addClass('u-canceling-weather');
      $(this).siblings('.js-cancelation-status').removeClass('u-display--hidden').addClass('u-display--block');
    });

    $('.js-weather-abort').on('click', function (e) {
      e.preventDefault();
      $(this).parents('.c-card-tribe-event').removeClass('u-canceling-weather');
      $(this).parents('.js-cancelation-status').removeClass('u-display--block').addClass('u-display--hidden');
    });

    $('.js-weather-confirm').on('click', function (e) {
      e.preventDefault();
      let classId = $(this).attr('data-id');
      let progress = $(this).parents('.js-cancelation-status').children('.js-confirmed');
      let classStatus = progress.children().first();
      let apiStatus = classStatus.siblings('.js-confirmed-item');

      $(this).parents('.js-cancelation-status').attr("data-confirmed", "true");

      setTimeout(function () {
        $.ajax({
          beforeSend: function () {
            classStatus.addClass('working');
            apiStatus.addClass('working');
          },
          type: "POST",
          url: "/wp-admin/admin-ajax.php",
          data: {
            action: "weather_cancel",
            event_id: classId
          }
        }).done(function (response) {

          console.log("Response from /wp-admin/admin-ajax.php action - weather_cancel");
          console.log(response);

          //clean up the response we get back because it has a 0 at the end of the JSON
          //it comes back as {JSON STRING}0
          //so we need to get the JSON only
          let matches;
          const regex = /.*}/gm;
          while ((matches = regex.exec(response)) !== null) {
            // This is necessary to avoid infinite loops with zero-width matches
            if (matches.index === regex.lastIndex) {
              regex.lastIndex++;
            }

            // The result can be accessed through the `m`-variable.
            matches.forEach((match, groupIndex) => {
              console.log(`Found match, group ${groupIndex}: ${match}`);
            });

            response = matches[0];
            console.log('inside .js-weather-confirm');
            console.log(`response ${response}`);
            let classInfo = JSON.parse(response);
            console.log(`classInfo ${classInfo}`);


            classStatus.removeClass('working').addClass('complete');
            /*
              We call an async function to await result of all api calls and check for success / failure.
              The function "weatherAPICall" below is an ES6 async function
              that needed to be loaded outside of the compiled js for use.
              It can be found under "resources/assets/scripts/util/weather-cancelation.js"
              and it is enqueued in "setup.php"
            */
            console.log('calling weatherAPICall');
            // console.log(`classInfo ${classInfo}`);
            // console.log(`response ${response}`);
            // const values = Object.values(classInfo);
            // console.log(values);
            weatherAPICall(classInfo);

          }

        });

      }, 1800);

    });



    /**
     * 4. Student Checkin Functionality -- aka Post Class Trigger
     */
    //Student "View Roster" Check In
    $(".js-student-check-in").on("click", function (e) {
      e.preventDefault();
      var student_userId = $(this).data("user-id");

      $.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        data: {
          action: "checkin_checkout",
          studentId: student_userId
        }
      }).done(function (response) {
        let checkinInfo = JSON.parse(response);
        postClassTrigger(checkinInfo);
      });

      $(this).toggleClass('is-checked').toggleClass('o-button--outline');
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },

};



// WEBPACK FOOTER //
// ./scripts/routes/common.js